import React, { useContext, useEffect, useMemo, useState } from "react";
import Close from "../../../../../images/Close.svg";
import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { TableHeaderProps } from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import
{
  GridAlignment,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import
{
  AttendanceTypes,
  empType,
  Operation,
} from "../../../../../utils/Enum.types";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { Button } from "../../../../../stories/Button/Button";
import { AppContext } from "../../../../../context/context";
import { EmpMaster, EmpMasterEdge } from "../../users/queries/types";
import { useLazyQuery } from "@apollo/client";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { EMPTY_STRING } from "../../../../../utils/constants";
import
{
  GetMomAttResult,
  GetMomAttVars,
  GetMomInviteesResult,
  GetMomInviteesVars,
} from "../queries/types";
import { GetMomAtt, GetMomInvitees } from "../queries/query";
import { CustomDrawer } from "../../../../../styles/CustomDrawerStyles";
import EmployeeAttendance from "../planning/EmployeeAttendance";
import { GetProjectNameInNodeId } from "../../masters/projects/queries/queries";
import { nodeVar } from "../../../../../utils/commonQueryTypes";
import { AtsAcLdgrProjects } from "../../masters/projects/queries/types";

interface Props
{
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  momId: number;
  latest: boolean;
}
const AttendedEmployeesList = ( { setModalFlag, momId, latest }: Props ) =>
{
  const { MinutesOfMeeting } = useAssetTableJson();
  const { state } = useContext( AppContext );
  const [ columnVisibilityModel, setColumnVisibilityModel ] =
    useState<GridColumnVisibilityModel>( {} );
  const [ markAttendance, setMarkAttendance ] = useState( false );

  const { customer_id, projectID } = useUrlParams();

  const [ searchEmployee, setSearchEmployee ] = useState( "" );

  const [ GetProject, { data: projectNameData } ] = useLazyQuery<
    { node: AtsAcLdgrProjects },
    nodeVar
  >( GetProjectNameInNodeId );

  const [ GetAtt, { data: attData } ] = useLazyQuery<
    GetMomAttResult,
    GetMomAttVars
  >( GetMomAtt );

  const [ GetInvitees, { data: inviteesAtt } ] = useLazyQuery<
    GetMomInviteesResult,
    GetMomInviteesVars
  >( GetMomInvitees );



  useEffect( () =>
  {
    if ( projectID )
    {
      GetProject( {
        variables: {
          id: projectID,
        },
      } );
    }
  }, [ projectID, GetProject ] );

  useEffect( () =>
  {
    if ( customer_id && momId )
    {
      GetAtt( {
        variables: {
          customerID: customer_id,
          momID: momId,
          projectID: projectID ? projectID : -1,
          latest,
        },
      } );
    }
  }, [ customer_id, GetAtt, momId, projectID ] );

  useEffect( () =>
  {
    if ( customer_id && momId )
    {
      GetInvitees( {
        variables: {
          customerID: customer_id,
          momID: momId,
          projectID: projectID ? projectID : -1,
          latest
        },
      } );
    }
  }, [ customer_id, GetInvitees, momId, projectID, latest ] );

  const dynamicHeaders: TableHeaderProps[] = MinutesOfMeeting.Attended.filter(
    ( header ) => header.field !== "status" && header.field !== "vendor_name"
  ).map( ( header ) => ( {
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    renderCell: ( params ) =>
    {
      if ( header.field === "status" )
      {
        return (
          <>
            <span
              className={
                params.row.status === AttendanceTypes.Present
                  ? "font-green"
                  : "font-red"
              }
            >
              {params.row.status}
            </span>
          </>
        );
      } else return params.value;
    },
  } ) );

  const columns = [ ...dynamicHeaders ];
  const rows: GridValidRowModel[] = useMemo( () =>
  {
    return attData
      ? attData.GetMomAtt.map( ( node, index ) => ( {
        id: index + 1,
        employee_name: node.empDetails.name,
        user_type: node.empDetails.empType,
        empNode: node,
      } ) ).filter(
        ( res ) =>
          res.employee_name
            .toLocaleLowerCase()
            .includes( searchEmployee.toLocaleLowerCase() ) ||
          searchEmployee === EMPTY_STRING
      )
      : [];
  }, [ attData, searchEmployee ] );

  useEffect( () =>
  {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MOM_ATTENDED_DETAILS
    );
    if ( savedModel )
    {
      setColumnVisibilityModel( JSON.parse( savedModel ) );
    }
  }, [] );

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) =>
  {
    setColumnVisibilityModel( newModel );
    localStorage.setItem(
      ColumnVisibilityFor.MOM_ATTENDED_DETAILS,
      JSON.stringify( newModel )
    );
  };

  return (
    <div className="att-emp-list">
      <div className="att-emp-list__title">
        <Title>Employee Attendance</Title>
        <img src={Close} alt="" onClick={() => setModalFlag( false )} />
      </div>
      <Input id="data_search" placeholder="Search..." />

      <div className="att-emp-list__subtitle">
        <b className="font-green">Attended</b>
      </div>
      <div
        className={`att-emp-list__tableblock--view`}
      >
        <StyledDatagrid
          columns={columns}
          rows={rows}
          rowHeight={TABLE_ROW_HEIGHT}
          disableRowSelectionOnClick
          hideFooter
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
        />
        {inviteesAtt && inviteesAtt.GetMomInvitees.length ? <>
          <Title variant="subtitle1"> Attended Invitees</Title>
          <div className="att-emp-list__invities--list--view">
            {inviteesAtt &&
              inviteesAtt.GetMomInvitees.map( ( res, index ) =>
              {
                return (
                  <span>{res}</span>
                );
              } )
            }
          </div>
        </> : null}
      </div>



      <Button mode="cancel" onClick={() => setModalFlag( false )} />

      <CustomDrawer
        anchor="right"
        open={markAttendance}
        onClose={() => setMarkAttendance( !markAttendance )}
      >
        <EmployeeAttendance
          setModalFlag={setMarkAttendance}
          ldgrID={projectID!}
          name={projectNameData ? projectNameData.node.name : ""}
          operation={Operation.UPDATE}
        />
      </CustomDrawer>
    </div>
  );
};

export default AttendedEmployeesList;
